export default __webpack_public_path__ + "static/media/boreal_wolfs_cracked_tooth.53236d7d.png";